import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Navigation, Pagination } from 'swiper/modules';

const ImageSlider = ({ images }: { images: string[] }) => {
  return (
    <Swiper
      spaceBetween={30}
      slidesPerView={1}
      modules={[Navigation]}
      scrollbar={{ draggable: true }}
      navigation={{
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }}
    >
      {images.map((imageUrl: string, index: number) => (
        <SwiperSlide key={index}>
          <img src={imageUrl} alt={`Slide ${index}`} />
        </SwiperSlide>
      ))}
      <div className="swiper-button-next after:hidden text-custom-500">
        <ChevronRight />
      </div>
      <div className="swiper-button-prev after:hidden text-custom-500">
        <ChevronLeft />
      </div>
    </Swiper>
  );
};

export default ImageSlider;
